var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"instantaneousData d-flex justify-content-center align-items-start flex-column w-100 h-100"},[_c('ScaniaBar',_vm._b({},'ScaniaBar',{
        min: 20,
        max: 36,
        value: _vm.telemetry2.truck.batteryVoltage,
        unit: 'V',
        displayMidLabel: false
      },false),[_c('i',{staticClass:"icon icon-scania-battery_red"})]),_c('ScaniaBar',_vm._b({},'ScaniaBar',{
        min: 0,
        max: 175,
        value: _vm.telemetry2.truck.brakeAirPressure,
        unit: _vm.$unitReadable('unit_pressure')
      },false),[_c('i',{staticClass:"icon icon-scania-parking-break_red"})]),_c('ScaniaBar',_vm._b({},'ScaniaBar',{
        min: 0,
        max: 100,
        value:
          (_vm.telemetry2.truck.adBlueLevel * 100) /
          _vm.telemetry2.truck.adBlueCapacity,
        unit: '%'
      },false),[_c('i',{staticClass:"icon icon-scania-ad-blue-low_yellow"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }